import type { RouteObject } from 'react-router';
import { handle } from '@/app/router/handle';

export const cashAndBillingRoutes: RouteObject = {
  path: 'cash-and-billing',
  children: [
    {
      path: 'certificate-summary',
      handle: handle('certificateSummary'),
      lazy: () =>
        import('./CertificateSummaryPage').then((module) => ({
          Component: module.CertificateSummaryPage,
        })),
    },
  ],
};
